/*** IMPORTS FROM imports-loader ***/
var angular = require("angular");

module.exports = "<p>\n  <small class=\"text-muted\">Web app framework base on Bootstrap and AngularJS<br>&copy; 2014</small>\n</p>"



//////////////////
// WEBPACK FOOTER
// ./~/imports-loader?angular!./src/app/blocks/page_footer.html
// module id = 156
// module chunks = 1